var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 113,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 52,
    width: 125,
    height: 113
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31)",
    transform: "translate(-299 -52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5755 56.5917 142.626 56.5917 142.626 107.772 85.5755 107.772Z",
    stroke: "current",
    strokeWidth: 1.26116,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00061 0 0 1 214.015 -3.94968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.165 56.5917 209.215 56.5917 209.215 107.772 152.165 107.772Z",
    stroke: "current",
    strokeWidth: 1.26116,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00061 0 0 1 214.015 -3.94968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5755 117.127 142.626 117.127 142.626 168.308 85.5755 168.308Z",
    stroke: "current",
    strokeWidth: 1.26116,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00061 0 0 1 214.015 -3.94968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.165 117.127 209.215 117.127 209.215 168.308 152.165 168.308Z",
    stroke: "current",
    strokeWidth: 1.26116,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1.00061 0 0 1 214.015 -3.94968)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout1);
export default __webpack_public_path__ + "static/media/layout1.1b200ee4c64054821eab062af762c8b3.svg";
export { ForwardRef as ReactComponent };